import script from "./FirstTimerPrayerRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstTimerPrayerRequest.vue?vue&type=script&setup=true&lang=js"

import "./FirstTimerPrayerRequest.vue?vue&type=style&index=0&id=2789d739&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2789d739"]])

export default __exports__